var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Header extends Component {
    constructor() {
        super('Header', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            const splashScreenHasBeenShown = sessionStorage.getItem('splashScreenHasBeenShown');
            setTimeout(() => {
                this.switchLogo();
            }, splashScreenHasBeenShown !== 'true' ? 12000 : 0);
            $('body').on('splashScreenClosed', () => {
                console.log('Splash screen closed, switching logo...');
                this.switchLogo();
            });
            this.success();
        });
    }
    switchLogo() {
        const isNewLogoShown = sessionStorage.getItem('is_new_logo_shown');
        if (isNewLogoShown !== 'true') {
            $('#logo').removeClass('d-none').addClass('d-block');
            setTimeout(() => {
                sessionStorage.setItem('is_new_logo_shown', 'true');
                $('#logo').addClass('fade-out');
                setTimeout(() => {
                    $('#logo-new').removeClass('d-none').addClass('d-block');
                }, 3000);
            }, 3000);
        }
        else {
            $('#logo').addClass('d-none');
            $('#logo-new').removeClass('d-none').addClass('d-block');
        }
    }
}
